import { render, staticRenderFns } from "./ChangeNotificationThanks.vue?vue&type=template&id=6de70731&"
import script from "./ChangeNotificationThanks.vue?vue&type=script&lang=js&"
export * from "./ChangeNotificationThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports